












import Vue from 'vue';
import { Component, Watch, Mixins, Prop } from 'vue-property-decorator';

import MutationObserverMixin from '@/shared/mixins/MutationObserverMixin';

@Component
export default class GrabInTheBottom extends Mixins(MutationObserverMixin) {
  @Prop({ default: true }) isGrabbed: boolean;

  $refs!: {
    grabBox: HTMLElement;
    grabBoxContainer: HTMLElement;
  };

  setContainerHeight(): void {
    const {grabBox, grabBoxContainer} = this.$refs;
    grabBoxContainer.style.height = `${grabBox.clientHeight}px`;
  }

  mounted(): void {
    this.addObserver(this.setContainerHeight, document.body);
    window.addEventListener('resize', this.setContainerHeight);
  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.setContainerHeight);
  }
}
